var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 219,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.864 204.383C81.7533 204.383 50.2127 172.843 50.2127 133.732 50.2127 94.6219 81.7533 63.0813 120.864 63.0813 159.974 63.0813 191.515 94.6219 191.515 133.732L191.515 133.732C191.767 172.843 160.226 204.383 120.864 204.383ZM180.665 72.165 188.235 64.5952C191.01 61.5673 191.01 56.7731 187.982 53.9976 184.954 51.222 180.412 50.9697 177.385 53.7452L168.805 62.5766C156.694 54.5022 142.816 49.4557 128.433 48.4464L128.433 37.8488 151.143 37.8488 151.143 22.7093 90.5847 22.7093 90.5847 37.8488 113.294 37.8488 113.294 48.1941C65.8568 52.2313 31.036 94.1173 35.0732 141.302 39.1104 188.487 80.9963 223.56 128.181 219.523 175.366 215.486 210.439 173.6 206.402 126.415 204.888 105.724 195.552 86.5475 180.665 72.165Z",
    transform: "matrix(1 0 0 1.00227 -23.7291 238.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.91 133.732 125.91 73.4266C124.144 73.1743 122.63 73.1743 120.864 73.1743 119.097 73.1743 117.583 73.1743 115.817 73.4266L115.817 133.732 125.91 133.732Z",
    transform: "matrix(1 0 0 1.00227 -23.7291 238.108)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNever);
export default __webpack_public_path__ + "static/media/never.904b69be492ad055d6c10503fba40e14.svg";
export { ForwardRef as ReactComponent };